import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { isRetoucher } from "@/features/retouch/permissions";

/**
 * Nhận / Bận / giờ nhận việc. Middleware BE lọc VAI (retouch.dispatch.respond
 * cấp cho cả `staff`), service lọc PHÒNG — nên ở đây kiểm CẢ HAI, không thì
 * khối "Máy chào" hiện cho lễ tân rồi gọi API ăn 403 (bài học canClaimRetouchOrder).
 */
export function canRespondRetouchDispatch(s: Staff | null | undefined): boolean {
  if (!s) return false;
  return hasPermission(ACTION.RetouchDispatchRespond) && isRetoucher(s);
}

/** Bảng Theo dõi + nút "Nhờ máy chào" + đọc bảng thợ/cấu hình. */
export function canReadRetouchDispatch(s: Staff | null | undefined): boolean {
  if (!s) return false;
  return hasPermission(ACTION.RetouchDispatchRead);
}

/**
 * Sửa cấu hình / hồ sơ thợ. Action cấp cho `manager` chung (auth không biết
 * phòng), service BE gác lại manager phải thuộc phòng hậu kỳ — gương ở đây.
 */
export function canConfigureRetouchDispatch(s: Staff | null | undefined): boolean {
  if (!s) return false;
  if (!hasPermission(ACTION.RetouchDispatchConfigWrite)) return false;
  const role = (s.role || "").trim().toLowerCase();
  if (role === "admin" || role === "director") return true;
  return role === "manager" && (s.department || "").trim().toLowerCase() === "retouch";
}
